import { render, staticRenderFns } from "./SocialMediaTag.vue?vue&type=template&id=0a976404&scoped=true&"
import script from "./SocialMediaTag.vue?vue&type=script&lang=ts&"
export * from "./SocialMediaTag.vue?vue&type=script&lang=ts&"
import style0 from "./SocialMediaTag.vue?vue&type=style&index=0&id=0a976404&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a976404",
  null
  
)

export default component.exports